

<!-- <div class="bar_chart">
   <div *ngIf="loading" class="loader-container">
       <app-loader-component></app-loader-component>
   </div>

   <div *ngIf="hasData" class="no-data">
       No Data
   </div>


</div> -->
<div class="bar_chart" *ngIf="!noData">
   <div style="display: block;">
       <canvas #chartCanvas></canvas>
   </div>
</div>

<div *ngIf="noData" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Chart Data Available!</p>
</div>

